import { DRAG_BUTTON_PATH } from 'BomdisoftComponents/icons/render';

export * from 'BomdisoftComponents/icons/abc-rounded';
export * from 'BomdisoftComponents/icons/account-balance-rounded';
export * from 'BomdisoftComponents/icons/add-rounded';
export * from 'BomdisoftComponents/icons/admin-panel-settings-outlined';
export * from 'BomdisoftComponents/icons/admin-panel-settings-rounded';
export * from 'BomdisoftComponents/icons/all-inclusive-rounded';
export * from 'BomdisoftComponents/icons/analytics-rounded';
export * from 'BomdisoftComponents/icons/archive-rounded';
export * from 'BomdisoftComponents/icons/arrow-downward-rounded';
export * from 'BomdisoftComponents/icons/arrow-drop-down-rounded';
export * from 'BomdisoftComponents/icons/arrow-forward-rounded';
export * from 'BomdisoftComponents/icons/assured-workload-rounded';
export * from 'BomdisoftComponents/icons/attach-money-rounded';
export * from 'BomdisoftComponents/icons/auto-awesome';
export * from 'BomdisoftComponents/icons/base';
export * from 'BomdisoftComponents/icons/bolt';
export * from 'BomdisoftComponents/icons/calendar-month-rounded';
export * from 'BomdisoftComponents/icons/camera-alt-rounded';
export * from 'BomdisoftComponents/icons/campaign';
export * from 'BomdisoftComponents/icons/card-giftcard-rounded';
export * from 'BomdisoftComponents/icons/card-membership-rounded';
export * from 'BomdisoftComponents/icons/casino-rounded';
export * from 'BomdisoftComponents/icons/category-rounded';
export * from 'BomdisoftComponents/icons/chat-bubble-outline-rounded';
export * from 'BomdisoftComponents/icons/chat-rounded';
export * from 'BomdisoftComponents/icons/check';
export * from 'BomdisoftComponents/icons/check-box';
export * from 'BomdisoftComponents/icons/check-box-outline-blank';
export * from 'BomdisoftComponents/icons/check-circle';
export * from 'BomdisoftComponents/icons/check-circle-outline-outlined';
export * from 'BomdisoftComponents/icons/check-circle-rounded';
export * from 'BomdisoftComponents/icons/check-rounded';
export * from 'BomdisoftComponents/icons/chevron-left';
export * from 'BomdisoftComponents/icons/chevron-right';
export * from 'BomdisoftComponents/icons/clear';
export * from 'BomdisoftComponents/icons/close-rounded';
export * from 'BomdisoftComponents/icons/code';
export * from 'BomdisoftComponents/icons/code-rounded';
export * from 'BomdisoftComponents/icons/collections-rounded';
export * from 'BomdisoftComponents/icons/content-copy';
export * from 'BomdisoftComponents/icons/credit-card-rounded';
export * from 'BomdisoftComponents/icons/csv-file';
export * from 'BomdisoftComponents/icons/currency-pound-rounded';
export * from 'BomdisoftComponents/icons/dashboard-customize-outlined';
export * from 'BomdisoftComponents/icons/dashboard-customize-rounded';
export * from 'BomdisoftComponents/icons/data-object';
export * from 'BomdisoftComponents/icons/data-saver-on-rounded';
export * from 'BomdisoftComponents/icons/delete-rounded';
export * from 'BomdisoftComponents/icons/devices-rounded';
export * from 'BomdisoftComponents/icons/do-not-disturb-rounded';
export * from 'BomdisoftComponents/icons/done';
export * from 'BomdisoftComponents/icons/drag-indicator-rounded';
export * from 'BomdisoftComponents/icons/edit-rounded';
export * from 'BomdisoftComponents/icons/email-rounded';
export * from 'BomdisoftComponents/icons/emoji-events-rounded';
export * from 'BomdisoftComponents/icons/emoji-objects-rounded';
export * from 'BomdisoftComponents/icons/engineering-rounded';
export * from 'BomdisoftComponents/icons/error-outline-outlined';
export * from 'BomdisoftComponents/icons/euro-rounded';
export * from 'BomdisoftComponents/icons/euro-symbol-rounded';
export * from 'BomdisoftComponents/icons/expand-more';
export * from 'BomdisoftComponents/icons/expand-more-rounded';
export * from 'BomdisoftComponents/icons/facebook';
export * from 'BomdisoftComponents/icons/facebook-rounded';
export * from 'BomdisoftComponents/icons/favorite-rounded';
export * from 'BomdisoftComponents/icons/file-download-rounded';
export * from 'BomdisoftComponents/icons/filter-alt-rounded';
export * from 'BomdisoftComponents/icons/filter-list';
export * from 'BomdisoftComponents/icons/flag';
export * from 'BomdisoftComponents/icons/flag-rounded';
export * from 'BomdisoftComponents/icons/folder-outlined';
export * from 'BomdisoftComponents/icons/folder-rounded';
export * from 'BomdisoftComponents/icons/format-list-bulleted';
export * from 'BomdisoftComponents/icons/format-quote';
export * from 'BomdisoftComponents/icons/fullscreen-exit-rounded';
export * from 'BomdisoftComponents/icons/fullscreen-rounded';
export * from 'BomdisoftComponents/icons/gavel-rounded';
export * from 'BomdisoftComponents/icons/github';
export * from 'BomdisoftComponents/icons/gpp-good-rounded';
export * from 'BomdisoftComponents/icons/group-rounded';
export * from 'BomdisoftComponents/icons/groups';
export * from 'BomdisoftComponents/icons/groups-rounded';
export * from 'BomdisoftComponents/icons/height-rounded';
export * from 'BomdisoftComponents/icons/help-rounded';
export * from 'BomdisoftComponents/icons/highlight-off-rounded';
export * from 'BomdisoftComponents/icons/history';
export * from 'BomdisoftComponents/icons/home-rounded';
export * from 'BomdisoftComponents/icons/horizontal-rule';
export * from 'BomdisoftComponents/icons/hub';
export * from 'BomdisoftComponents/icons/image';
export * from 'BomdisoftComponents/icons/import-contacts-rounded';
export * from 'BomdisoftComponents/icons/indeterminate-check-box';
export * from 'BomdisoftComponents/icons/indeterminate-check-box-outlined';
export * from 'BomdisoftComponents/icons/info';
export * from 'BomdisoftComponents/icons/info-outlined';
export * from 'BomdisoftComponents/icons/insights';
export * from 'BomdisoftComponents/icons/instagram';
export * from 'BomdisoftComponents/icons/keyboard-arrow-down-rounded';
export * from 'BomdisoftComponents/icons/lightbulb-rounded';
export * from 'BomdisoftComponents/icons/link-rounded';
export * from 'BomdisoftComponents/icons/linkedin';
export * from 'BomdisoftComponents/icons/location-on';
export * from 'BomdisoftComponents/icons/location-on-rounded';
export * from 'BomdisoftComponents/icons/lock-open-rounded';
export * from 'BomdisoftComponents/icons/lock-rounded';
export * from 'BomdisoftComponents/icons/login-rounded';
export * from 'BomdisoftComponents/icons/logout';
export * from 'BomdisoftComponents/icons/logout-rounded';
export * from 'BomdisoftComponents/icons/looks-one';
export * from 'BomdisoftComponents/icons/mail-outlined';
export * from 'BomdisoftComponents/icons/menu-rounded';
export * from 'BomdisoftComponents/icons/miscellaneous-services-rounded';
export * from 'BomdisoftComponents/icons/monetization-on-rounded';
export * from 'BomdisoftComponents/icons/money-off-rounded';
export * from 'BomdisoftComponents/icons/more-horiz-rounded';
export * from 'BomdisoftComponents/icons/more-rounded';
export * from 'BomdisoftComponents/icons/more-vert-rounded';
export * from 'BomdisoftComponents/icons/notes';
export * from 'BomdisoftComponents/icons/notes-rounded';
export * from 'BomdisoftComponents/icons/notifications-off-rounded';
export * from 'BomdisoftComponents/icons/notifications-rounded';
export * from 'BomdisoftComponents/icons/ondemand-video-rounded';
export * from 'BomdisoftComponents/icons/open-in-new-rounded';
export * from 'BomdisoftComponents/icons/password-rounded';
export * from 'BomdisoftComponents/icons/pause-rounded';
export * from 'BomdisoftComponents/icons/payment-rounded';
export * from 'BomdisoftComponents/icons/payments-rounded';
export * from 'BomdisoftComponents/icons/people';
export * from 'BomdisoftComponents/icons/people-alt-rounded';
export * from 'BomdisoftComponents/icons/people-outlined';
export * from 'BomdisoftComponents/icons/people-rounded';
export * from 'BomdisoftComponents/icons/person';
export * from 'BomdisoftComponents/icons/person-add-rounded';
export * from 'BomdisoftComponents/icons/person-outlined';
export * from 'BomdisoftComponents/icons/person-rounded';
export * from 'BomdisoftComponents/icons/phone-rounded';
export * from 'BomdisoftComponents/icons/play-arrow-rounded';
export * from 'BomdisoftComponents/icons/policy-rounded';
export * from 'BomdisoftComponents/icons/power-settings-new';
export * from 'BomdisoftComponents/icons/print-rounded';
export * from 'BomdisoftComponents/icons/priority-high-rounded';
export * from 'BomdisoftComponents/icons/privacy-tip-rounded';
export * from 'BomdisoftComponents/icons/public-rounded';
export * from 'BomdisoftComponents/icons/receipt-long-rounded';
export * from 'BomdisoftComponents/icons/receipt-rounded';
export * from 'BomdisoftComponents/icons/refresh-rounded';
export * from 'BomdisoftComponents/icons/replay-rounded';
export * from 'BomdisoftComponents/icons/report-problem-outlined';
export * from 'BomdisoftComponents/icons/restore-rounded';
export * from 'BomdisoftComponents/icons/reviews-rounded';
export * from 'BomdisoftComponents/icons/rocket-launch-rounded';
export * from 'BomdisoftComponents/icons/savings-rounded';
export * from 'BomdisoftComponents/icons/schedule-rounded';
export * from 'BomdisoftComponents/icons/school-rounded';
export * from 'BomdisoftComponents/icons/search';
export * from 'BomdisoftComponents/icons/search-rounded';
export * from 'BomdisoftComponents/icons/security-rounded';
export * from 'BomdisoftComponents/icons/sell-outlined';
export * from 'BomdisoftComponents/icons/send-rounded';
export * from 'BomdisoftComponents/icons/settings-rounded';
export * from 'BomdisoftComponents/icons/share';
export * from 'BomdisoftComponents/icons/shield';
export * from 'BomdisoftComponents/icons/skip-next-rounded';
export * from 'BomdisoftComponents/icons/skip-previous-rounded';
export * from 'BomdisoftComponents/icons/spreadsheet-file';
export * from 'BomdisoftComponents/icons/star-rounded';
export * from 'BomdisoftComponents/icons/support-rounded';
export * from 'BomdisoftComponents/icons/swap-horiz-rounded';
export * from 'BomdisoftComponents/icons/table-chart';
export * from 'BomdisoftComponents/icons/terminal';
export * from 'BomdisoftComponents/icons/timeline';
export * from 'BomdisoftComponents/icons/timeline-rounded';
export * from 'BomdisoftComponents/icons/token-rounded';
export * from 'BomdisoftComponents/icons/trending-up-rounded';
export * from 'BomdisoftComponents/icons/tune-rounded';
export * from 'BomdisoftComponents/icons/update-rounded';
export * from 'BomdisoftComponents/icons/upload-rounded';
export * from 'BomdisoftComponents/icons/verified-rounded';
export * from 'BomdisoftComponents/icons/verified-user-rounded';
export * from 'BomdisoftComponents/icons/video-library';
export * from 'BomdisoftComponents/icons/view-column';
export * from 'BomdisoftComponents/icons/visibility';
export * from 'BomdisoftComponents/icons/visibility-off';
export * from 'BomdisoftComponents/icons/visibility-rounded';
export * from 'BomdisoftComponents/icons/volume-mute-rounded';
export * from 'BomdisoftComponents/icons/volume-up-rounded';
export * from 'BomdisoftComponents/icons/warning-rounded';
export * from 'BomdisoftComponents/icons/workspaces';
export * from 'BomdisoftComponents/icons/x';
export * from 'BomdisoftComponents/icons/zoom-in-rounded';

export type IconProps = {
  width?: number;
  height?: number;
  fill?: string;
};

export const DragButton = ({ width = 20, height = 20, fill = '#318FCE' }: IconProps) => (
  <svg aria-hidden='true' fill='none' height={height} viewBox='0 0 20 20' width={width} xmlns='http://www.w3.org/2000/svg'>
    <rect fill={fill} height={height} rx='4' width={width} />
    <path d={DRAG_BUTTON_PATH} fill='white' />
  </svg>
);
